import { quizStore } from '@/stores/quiz/quiz'

export default {
    // common getters

    getActiveSubModule: (state) => () => {
        const modalType = state.quizModalType;
        const modalSubType = state.quizModalSubType;

        const activeQuizModule = state[modalType] ? state[modalType] : {};
        const activeQuizSubModule = activeQuizModule[modalSubType];

        return activeQuizSubModule ? activeQuizSubModule : null;
    },

    getActiveQuizModalType: (state) => () => {
        return state.quizModalType;
    },

    getActiveQuizModalSubType: (state) => () => {
        return state.quizModalSubType;
    },

    getCurrentScreenNumber: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        if (module) {
            const currentScreen = module?.currentScreen;
            return currentScreen ? currentScreen : 0;
        }

    },

    getTotalScreens: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()


        if (module) {

            const totalScreens = module?.totalScreens;
            return totalScreens ? totalScreens : 0;
        }
    },


    getQuizModalHeadingData: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()
        let currentScreenNum = module?.currentScreen;
        const totalScreens = module?.totalScreens;

        if (module && currentScreenNum >= 0 && currentScreenNum < totalScreens) {

            const screenKeys = Object.keys(module?.screens);

            const activeScreen = module?.screens[screenKeys[currentScreenNum]];

            return activeScreen ? {
                title: activeScreen?.title,
                subtitle: activeScreen?.subtitle,
            } : null;
        }

    },

    getQuizModalMessage: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        let currentScreenNum = module?.currentScreen;
        const totalScreens = module?.totalScreens;

        if (module && currentScreenNum >= 0 && currentScreenNum < totalScreens) {

            const screenKeys = Object.keys(module?.screens);

            const activeScreen = module?.screens[screenKeys[currentScreenNum]];

            return activeScreen ? activeScreen?.message : null;
        }

    },

    getLoadingStatus: (state) => () => state.isLoading,


    // budget
    getBudget: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const priceScreen = module ? module?.screens?.price : null;

        if (priceScreen) {
            return priceScreen?.options?.to
        }
    },

    // quality

    getQualityData: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const qualityScreen = module ? module?.screens?.quality : null;

        if (qualityScreen) {
            return qualityScreen?.options
        }
    },

    getQuality: (state) => (type) => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const qualityScreen = module ? module?.screens?.quality : null;

        if (qualityScreen) {
            return qualityScreen?.options.find(item => item.value === type)
        }
    },

    // price
    getMinMax: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const priceScreen = module ? module?.screens?.price : null;


        if (priceScreen) {
            return priceScreen.options ? priceScreen.options : null
        }
    },

    // shape
    getShapeData: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const shapeScreen = module ? module?.screens?.shape : null;

        if (shapeScreen) {
            return shapeScreen?.options
        }
    },

    // style
    getStyleData: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const styleScreen = module ? module?.screens?.style : null;

        if (styleScreen) {
            return styleScreen?.options
        }
    },

    // metal
    getMetalData: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const metalScreen = module ? module?.screens?.metal : null;

        if (metalScreen) {
            return metalScreen?.options
        }
    },

    // size
    getSizeData: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const sizeScreen = module ? module?.screens?.size : null;

        if (sizeScreen) {
            return sizeScreen?.options
        }
    },

    // get Shop Types
    getShopTypes: (state) => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const shopTypes = module ? module?.screens?.style : null;

        if (shopTypes) {
            return shopTypes?.options
        }
    },


    getOptionsByScreenName: (state) => (screenName) => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const screen = module ? module?.screens[screenName] : null;

        if (screen) {
            return screen?.options
        }
    },


    // api getters
    getListApiUrl: (state) => () => {
        const store = quizStore()
        const modalType = store.getActiveQuizModalType()
        const modalSubType = store.getActiveQuizModalSubType()

        switch (modalType) {
            case 'cyo': {
                switch (modalSubType) {
                    case "ring":
                        return '/config/setting/list?Subtype=all'

                    case "diamond":
                        return '/diamond/filter/loose'
                }
                break
            }

            case 'shop': {
                return '/config/shop/list/'
            }
        }

    },

    // api getters
    getListingRoute: (state) => () => {
        const store = quizStore()
        const modalType = store.getActiveQuizModalType()
        const modalSubType = store.getActiveQuizModalSubType()

        const randomNumber = Math?.floor(10000 + Math?.random() * 90000)

        switch (modalType) {
            case 'cyo': {

                switch (modalSubType) {
                    case 'ring': {
                        return { url: '/engagement-rings/all', query: { RefreshKey: `${randomNumber}` } }
                    }

                    case 'diamond': {
                        return { url: '/loose-diamonds', query: { RefreshKey: `${randomNumber}` } };
                    }
                }
            }

            case 'preset': {
                switch (modalSubType) {
                    case 'ring': {
                        return { url: '/preset-engagement-rings', query: {} }
                    }
                }
                break
            }

            case 'instock': {

                switch (modalSubType) {
                    case 'ring': {
                        return { url: '/ready-to-ship-engagement-rings', query: {} }
                    }
                    case 'earring': {
                        return { url: '/ready-to-ship-earrings', query: {} }
                    }
                    case 'bracelet': {
                        return { url: '/diamond-jewelry', query: { Style: 'Tennis-bracelet,Fashion-bracelet', RefreshKey: 'all' } }
                    }
                    case 'necklace': {
                        return { url: '/diamond-jewelry', query: { Style: 'Tennis-necklace,Solitaire-necklace,Fashion-necklace', refreshKeyTwo: 'all' } }
                    }
                    case 'all': {
                        return { url: '/diamond-jewelry', query: { Shipdate: 'any', refreshKeyTwo: 'all' } }
                    }
                }
                break
            }

            case 'shop': {
                return { url: '/diamond-jewelry', query: { RefreshKey: `${randomNumber}` } }
            }

            case 'readyToShip': {
                return { url: '/ready-to-ship-engagement-rings', query: {} }
            }
        }

    },


    getPayload: () => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()
        let payload = { page: 1, DiamondQuiz: 'Yes' }

        if (module) {
            const screens = module.screens
            Object.keys(screens).forEach((key) => {
                const screen = screens[key]
                switch (screen?.type) {
                    case 'select': {
                        let active = screen.options.find(item => !!item.active)
                        payload[screen.url] = active?.url

                        break;
                    }

                    case 'multiselect': {
                        let activeUrls = screen.options.filter(item => !!item.active)?.map(item => item.url)
                        payload[screen.url] = activeUrls.join(',')

                        break;
                    }

                    case 'price': {
                        let budget = screen.options.from //user selected value/budget
                        let sliderMin = screen.options.min // slider min value
                        let sliderMax = screen.options.max // slider max value

                        function getBudgetMinMax(minPercent, maxPercent) {
                            let minmax = {
                                min: sliderMin,
                                max: budget
                            }

                            const budgetMin = parseInt(budget - (budget * minPercent))
                            const budgetMax = parseInt(budget + (budget * maxPercent))

                            if (budgetMin > sliderMin && budgetMax < sliderMax) {
                                minmax.min = budgetMin
                                minmax.max = budgetMax
                            } else if (budgetMin > sliderMin && budgetMax > sliderMax) {
                                minmax.min = budgetMin
                                minmax.max = sliderMax
                            } else {
                                minmax.min = sliderMin
                                minmax.max = budgetMax
                            }
                            return minmax
                        }

                        const { min, max } = getBudgetMinMax(0.20, 0.20)

                        payload.PriceFrom = min
                        payload.PriceTo = max

                        break;
                    }

                    // case 'email':{
                    //     payload[screen.url] = screen.email
                    //     break;   
                    // }

                    case 'quality': {

                        let activeQuality = screen.options.find(item => !!item.active)
                        
                        if (activeQuality) {
                            if(activeQuality?.payload){
                                payload = {...payload, ...activeQuality.payload }
                            }
                            // payload['Sort'] = activeQuality.payload?.sort
                            // payload['Color'] = activeQuality.payload?.color
                            // payload['Clarity'] = activeQuality.payload?.clarity
                            // payload['DiamondQuality'] = activeQuality.payload?.quality
                            
                        }
                        break;
                    }

                }
            })
        }

        return payload
    },

    getEmailSuccessMessage: () => () => {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const screen = module ? module?.screens?.email : null;

        if (screen) {
            return screen?.successMessage
        }
    },

    getQuizType: () => () => {
        const store = quizStore()
        const quizType = store.getActiveQuizModalType()
        const quizSubType = store.getActiveQuizModalSubType()

        switch (quizType) {
            case 'cyo': {
                switch (quizSubType) {
                    case 'ring': {
                        return 'engagementRingQuiz'
                    }

                    case 'diamond': {
                        return 'diamondQuiz'
                    }
                }

                break;
            }

            case 'shop': {
                return 'shopQuiz'
            }
        }
    },

    getSelectedQuizType: (state) => () => {
        return state.selectedQuiz
    },

    getSelectedQuizSubType: (state) => () => {
        return state.selectedSubQuiz
    },
}
